const ProductList = () => import('../../pages/products/ProductList');

export default [
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
    name: 'alphabet-stamp-accessories',
    component: ProductList,
    props: {
      title: 'Accessoires pour tampons alphabets',
      description:
        "Widddi te permet de composer ton propre coffret de tampons alphabet, ultra pratique et polyvalent.<br/> Des tampons faciles à organiser, à ranger, à utiliser pour une efficacité maximale.<br/> Les sets de tampons alphabet Widddi peuvent s’utiliser avec des réglettes d’alignement simple ou double, pour un tamponnage bien droit et rapide. Ou avec des pinces à lettre super pratiques, pour un tamponnage facile et créatif. ",
      tags: ['set-tampon-alphabet', 'accessoires'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/accessoires/plateaux.jpg'),
          name: 'Accessoires',
          variant: 'Plateau de rangement',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires/plateau-rangement',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/couvercle.jpg'),
          name: 'Accessoires',
          variant: "Couvercle personnalisé",
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires/couvercle-personnalise',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/reglettes.jpg'),
          name: 'Accessoires',
          variant: "Réglette d'alignement",
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires/reglette-alignement',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/pince-tampons-alphabet.jpg'),
          name: 'Accessoires',
          variant: "Pince à lettres",
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires/pince-a-lettres',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/reglette-double.jpg'),
          name: 'Accessoires',
          variant: "Réglette d'alignement double",
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires/reglette-alignement-double',
        },
      ],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/accessoires/plateau-rangement',
    name: 'accessories-box',
    component: () => import('../../pages/products/creative/accessories/Box'),
    props: {
      src: require('../../../public/img/materiel-creatif/accessoires/plateaux.jpg'),
      type: 'Plateau de rangement',
      hiddenType: 'stamps',
      description:
        "Les plateaux de rangement te permettent d’organiser et de protéger tes caractères. <br/>La taille (A,B,C,D,E,F) correspond à la taille de ton set de tampons. Tous les plateaux s'empilent les uns sur les autres pour créer un coffret compact et facile à ranger. <br />Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-tampon-alphabet'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/accessoires/reglette-alignement',
    name: 'accessories-bar',
    component: () => import('../../pages/products/creative/accessories/Bar'),
    props: {
      src: require('../../../public/img/materiel-creatif/accessoires/reglettes.jpg'),
      type: "Réglette d'alignement",
      hiddenType: 'stamps',
      description:
        'La réglette d’alignement te permet de tamponner tes textes plus facilement et plus rapidement. Je l’ai spécialement conçue pour un centrage parfait. <br/>La taille (A,B,C,D,E,F) correspond à la taille de ton set de tampons (La réglette E est une réglette double).<br/> Retrouve plus de détails dans la description ci-dessous.',
      tags: ['set-tampon-alphabet'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/accessoires/couvercle-personnalise',
    name: 'accessories-lid',
    component: () => import('../../pages/products/creative/accessories/Lid'),
    props: {
      src: require('../../../public/img/materiel-creatif/accessoires/couvercle.jpg'),
      type: 'Couvercle personnalisé',
      hiddenType: 'stamps',
      description:
        'Un couvercle, simplement pour refermer ton coffret de tampons alphabet Widddi.<br/> Personnalise-le avec le texte de ton choix (max 20 caractères).<br/> Retrouve plus de détails dans la description ci-dessous.',
      tags: ['set-tampon-alphabet'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/accessoires/reglette-alignement-double',
    name: 'accessories-double-bar',
    component: () => import('../../pages/products/creative/accessories/DoubleBar'),
    props: {
      src: require('../../../public/img/materiel-creatif/accessoires/reglette-double.jpg'),
      type: "Réglette d'alignement double",
      hiddenType: 'bar',
      description:
        "La réglette d’alignement double te permet de tamponner tes textes 2 fois plus facilement et rapidement. Je l’ai spécialement conçue pour un centrage parfait. <br/>La taille (A,B,C,D,E,F) correspond à la taille de ton set de tampons. Tu peux choisir 2 tailles identiques pour les 2 lignes ou 2 tailles différentes pour associer plusieurs polices d'écriture. <br/> Retrouve plus de détails dans la description ci-dessous.",
      tags: ['set-tampon-alphabet'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/accessoires/pince-a-lettres',
    name: 'accessories-pliers',
    component: () => import('../../pages/products/creative/accessories/Pliers'),
    props: {
      src: require('../../../public/img/materiel-creatif/accessoires/pince-tampons-alphabet.jpg'),
      type: "Pinces à lettre et socle de présentation",
      hiddenType: 'pliers',
      description:
        "Parce que la réglette d'alignement n'est pas adaptée à toutes les situations, Widddi te permet d'utiliser ton set de tampons alphabet lettre par lettre sans galérer grâce à ses pinces à lettre ultra pratiques ! Elles sont idéales pour tamponner ton texte sur une surface non-plane, écrire en suivant une courbe, tamponner dans des endroits plus difficiles d’accès (à l’intérieur d’une tasse par exemple). Le socle de présentation te permet de garder tes pinces bien organisées et à portée de main avec les lettres bien visibles pour encore plus d'efficacité. <br/>La taille (A,B,C,D,E,F) correspond à la taille de ton set de tampons.<br/> Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['pince-a-lettres'],
    },
  },
];
